import { Box, Image, Text } from "@mantine/core";
import React from "react";
import "./connectionType.css";
import { connectionTypeProps } from "../../types/types";
import { Stack } from "@mui/material";

export function ConnectionType(props: connectionTypeProps) {

    return (
        <Stack className={`connection-box ${props.active ? "active" : ""}`} onClick={props.onClick}>
            <Image width={80} height={80} src={props.image} />
            <Text weight={700} size="sm" >
                {props.name}
            </Text>
        </Stack>
    );
}
